const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      this.productZoom();
    }
    productZoom = () => {
      document.querySelectorAll('.image-zoom').forEach( ele => {
        ele.addEventListener('mousemove', this._triggerZoom.bind(this))
        ele.addEventListener('mouseout', this._removeTrigger.bind(this))
    })
    }


    _triggerZoom = (e) => {
        let x,y;
        var zoomer = e.currentTarget.closest('.zoom');
        if(zoomer != null){
          e.target.classList.add('zooming');
          var offsetX = e.offsetX;
          var offsetY = e.offsetY;
          e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
          e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
          x = offsetX/zoomer.offsetWidth*100
          y = offsetY/zoomer.offsetHeight*100
          zoomer.style.backgroundPosition = x + '% ' + y + '%';
        }
        }
        
        _removeTrigger = (e) => {
          document.querySelectorAll('.zooming').forEach( ele => {
            ele.classList.remove('zooming')
          })
        }
    
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
